import { render } from "./UnAttachedTransaction.vue?vue&type=template&id=007eea14&scoped=true"
import script from "./UnAttachedTransaction.vue?vue&type=script&lang=js"
export * from "./UnAttachedTransaction.vue?vue&type=script&lang=js"

import "./UnAttachedTransaction.vue?vue&type=style&index=0&id=007eea14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007eea14"]])

export default __exports__